var _SocketChatCommand_socket;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class SocketChatCommand {
    constructor(socket) {
        _SocketChatCommand_socket.set(this, void 0);
        __classPrivateFieldSet(this, _SocketChatCommand_socket, socket, "f");
    }
    execute(privateKey, type, msg) {
        __classPrivateFieldGet(this, _SocketChatCommand_socket, "f").send({
            commandType: 'chat',
            resource: { userKey: privateKey, type, msg },
        });
    }
}
_SocketChatCommand_socket = new WeakMap();
